import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../reducers/reducer";
import AllocationView from "../../views/DashboardView/SustainabilityView/AllocationView/MainView";
import {
  toggleSimulation,
  toggleJoint,
  toggleSplitYear,
} from "../../reducers/sustainability/main";
import { startAllocation } from "../../reducers/sustainability/allocation/multiStep";
import {
  getSoldVolumes,
  createSoldVolumes,
  deleteSoldVolumes,
} from "../../reducers/sustainability/allocation/soldVolumes";

import {
  getConstructionDieselVolumes,
  createConstructionDieselVolumes,
  deleteConstructionDieselVolumes,
} from "../../reducers/sustainability/allocation/constructionDieselVolumes";

interface Props {
  isSimulation: boolean;
  isJoint: boolean;
  isFirstSplit: boolean;
  hasStarted: boolean;
  splitYear: any[];
  activePeriod: any;
  soldVolumes: any;
  constructionDieselVolumes: any;
  toggleSimulation: any;
  toggleJoint: any;
  toggleSplitYear: any;
  startAllocation: any;
  getSoldVolumes: any;
  createSoldVolumes: any;
  deleteSoldVolumes: any;
  getConstructionDieselVolumes: any;
  createConstructionDieselVolumes: any;
  deleteConstructionDieselVolumes: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      isSimulation: state.sustainability.main.isSimulation,
      isJoint: state.sustainability.main.isJoint,
      isFirstSplit: state.sustainability.main.isFirstSplit,
      hasStarted: state.sustainability.allocation.multiStep.hasStarted,
      splitYear: state.sustainability.main.splitYear,
      activePeriod: state.sustainability.main.activePeriod,
      soldVolumes: state.sustainability.allocation.soldVolumes,
      constructionDieselVolumes:
        state.sustainability.allocation.constructionDieselVolumes,
    }),
    (dispatch: any) => ({
      dispatch,
      toggleSimulation: () => dispatch(toggleSimulation()),
      toggleJoint: () => dispatch(toggleJoint()),
      toggleSplitYear: () => dispatch(toggleSplitYear()),
      startAllocation: () => dispatch(startAllocation()),
      getSoldVolumes: () => dispatch(getSoldVolumes()),
      createSoldVolumes: () => dispatch(createSoldVolumes()),
      deleteSoldVolumes: () => dispatch(deleteSoldVolumes()),
      getConstructionDieselVolumes: () =>
        dispatch(getConstructionDieselVolumes()),
      createConstructionDieselVolumes: () =>
        dispatch(createConstructionDieselVolumes()),
      deleteConstructionDieselVolumes: () =>
        dispatch(deleteConstructionDieselVolumes()),
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {
      //this.props.getSoldVolumes();
    },
  })
)(AllocationView);
